import FJIconBox from '@src/common/components/FJIconBox/FJIconBox';
import FJCutIcon from '@src/assets/cut.svg?react';
import FJDownloadIcon from '@src/assets/details-download.svg?react';
import FJPublishIcon from '@src/assets/publish.svg?react';
import FJPublishedIcon from '@src/assets/published.svg?react';
import FJTrimIcon from '@src/assets/trim.svg?react';
import FJMoreDropList from '../../FJMoreDropList/FJMoreDropList';
import FJLocalStore from '@src/store/FJLocalStore';
import styles from './FJDetailsCardToolbar.module.less';
import { useState } from 'react';
import type { FJPublishedItem } from '@src/types/FJDetails';

interface FJDetailsCardToolbarProps {
    clipId: string;
    /** 是否已发布（展示状态角标） */
    publishedList?: FJPublishedItem[];
    onPublishSocial?: () => void;
    onDownload?: (callback: () => void) => void;
    onTrim?: () => void;
    onCut?: (callback: () => void) => void;
    onMoreRename?: (id: string) => void;
    onMoreDelete?: (id: string) => void;
    onPublished?: () => void;
}

/**
 * 详情卡片工具条：已发布状态、发布到社交平台、下载、Trim、Cut、More。
 */
export default function FJDetailsCardToolbar({
    clipId,
    publishedList = [],
    onPublishSocial,
    onDownload,
    onTrim,
    onCut,
    onMoreRename,
    onMoreDelete,
    onPublished,
}: FJDetailsCardToolbarProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenInEditorLoading, setIsOpenInEditorLoading] = useState(false);
    const handleDownload = () => {
        setIsLoading(true);
        onDownload?.(() => {
            setIsLoading(false);
        });
    };
    const handleOpenInEditor = () => {
        setIsOpenInEditorLoading(true);
        onCut?.(() => {
            setIsOpenInEditorLoading(false);
        });
    };
    return (
        <div className={styles.root}>
            {publishedList?.length ? (
                <FJIconBox
                    icon={<FJPublishedIcon aria-hidden />}
                    tooltipTitle={FJLocalStore._('published')}
                    aria-label={FJLocalStore._('published')}
                    onClick={() => onPublished?.()}
                >
                    <span className={styles.published_num}>{publishedList?.length}</span>
                </FJIconBox>
            ) : null}
            <FJIconBox
                icon={<FJPublishIcon aria-hidden />}
                text={FJLocalStore._('publish')}
                aria-label={FJLocalStore._('publish')}
                onClick={() => onPublishSocial?.()}
            />
            <FJIconBox
                icon={<FJDownloadIcon aria-hidden />}
                tooltipTitle={FJLocalStore._('download')}
                aria-label={FJLocalStore._('download')}
                onClick={handleDownload}
                isLoading={isLoading}
            />
            <FJIconBox
                icon={<FJTrimIcon aria-hidden />}
                tooltipTitle={FJLocalStore._('trim')}
                aria-label={FJLocalStore._('trim')}
                onClick={() => onTrim?.()}
            />
            <FJIconBox
                icon={<FJCutIcon aria-hidden />}
                aria-label={FJLocalStore._('open-in-editor')}
                tooltipTitle={FJLocalStore._('open-in-editor')}
                onClick={handleOpenInEditor}
                isLoading={isOpenInEditorLoading}
            />
            <FJMoreDropList fileId={clipId} onRename={onMoreRename} onDelete={onMoreDelete} forbidWheelEvent={true} />
        </div>
    );
}
